import { type RouteRecordRaw } from 'vue-router'

export const customerAnalyticsRouter: RouteRecordRaw[] = [
  {
    component: async () => import('../views/CustomerAnalyticsView.vue'),
    meta: {
      authZ: ({ user }) => user.can('read', 'funnel'),
      title: 'website.analytics',
    },
    name: 'brand.customerAnalytics',
    path: 'customer-analytics',
  },
]
